import React from 'react';
import styled from 'styled-components';
import { IconProps } from './types';

const BoxIcon = (props: IconProps): JSX.Element => (
  // allow prop spreading for svg icon
  // eslint-disable-next-line
  <svg viewBox="0 0 36 36" {...props}>
    <path d="M16.875 16.628l-0.616-0.306c-0.278-0.138-0.391-0.476-0.253-0.754s0.476-0.391 0.754-0.253l0.927 0.462c0.191 0.095 0.312 0.29 0.312 0.504v17.471c0 0.413-0.431 0.686-0.804 0.508l-14.625-6.961c-0.196-0.093-0.321-0.291-0.321-0.508v-17.789c0-0.418 0.439-0.69 0.813-0.504l10.968 5.459c0.278 0.138 0.391 0.476 0.253 0.754s-0.476 0.391-0.754 0.253l-10.155-5.054v16.526l13.5 6.425v-16.232z" />
    <path d="M21.108 15.203c0.282-0.13 0.405-0.465 0.275-0.747s-0.465-0.405-0.747-0.275l-3.434 1.587c-0.199 0.092-0.326 0.291-0.326 0.511v17.471c0 0.407 0.418 0.679 0.79 0.514l15.75-6.961c0.204-0.090 0.335-0.292 0.335-0.514v-17.789c0-0.411-0.426-0.683-0.799-0.511l-9.673 4.471c-0.282 0.13-0.405 0.465-0.275 0.747s0.465 0.405 0.747 0.275l8.874-4.102v16.543l-14.625 6.464v-16.247l3.108-1.436z" />
    <path d="M3.031 9.518c-0.286 0.121-0.616-0.013-0.737-0.299s0.013-0.616 0.299-0.737l15.987-6.75c0.147-0.062 0.313-0.059 0.458 0.009l14.388 6.75c0.281 0.132 0.402 0.467 0.27 0.748s-0.467 0.402-0.748 0.27l-14.161-6.644-15.756 6.653z" />
    <path d="M12.693 5.007l0.488-1.014 15.188 7.312-0.488 1.014z" />
    <path d="M9.309 7.252c-0.277-0.14-0.389-0.478-0.249-0.755s0.478-0.389 0.755-0.249l14.001 7.053c0.19 0.096 0.309 0.29 0.309 0.502v5.614l2.874-1.158v-6.067c0-0.311 0.252-0.563 0.563-0.563s0.563 0.252 0.563 0.563v6.447c0 0.229-0.139 0.436-0.352 0.522l-3.999 1.612c-0.37 0.149-0.773-0.123-0.773-0.522v-6.1l-13.692-6.897z" />
  </svg>
);

const StyledBoxIcon = styled(BoxIcon)`
  width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
`;
export default StyledBoxIcon;
